<div class="summary-subcard" [ngClass]="{ 'is-missing': isMissing, 'light-blue': mode === 'secondary' }">
  <div class="summary-card-subheader">
    <b *ngIf="mode === 'secondary'">{{ title | translate }}</b>
    <h6 *ngIf="mode === 'primary'">{{ title | translate }}</h6>
    <ng-content select="[action]"></ng-content>
  </div>
  <div class="summary-subcard-body" [ngClass]="{ 'pt-2': mode === 'secondary' }">
    <ng-content *ngIf="!isMissing; else missingMessage"></ng-content>
    <ng-template #missingMessage>{{ missingMessageText | translate }}</ng-template>
  </div>
</div>
